import React, { useEffect, useRef, useState } from 'react';
import { Spin, Tabs } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import usePermission from '../../hooks/usePermission';
import { portalAdresi } from './markaApi';
import MarkaYonetimi from './MarkaYonetimi';
import '../ortak/nfmodules.css';

/**
 * Marka Portalı (07.10.2026). Portalın kendisi tasarımı değişmeden iframe'de
 * (backend static/marka-portal/index.html); veri /marka-portal/veri'den gelir.
 * Okuma yetkisi olan yalnız portalı görür; yazma yetkisi olana "Marka Yönetimi" sekmesi açılır.
 * Menüde yok (side_menu satırı bilerek eklenmedi); /marka-portal adresiyle açılır.
 */
export default function MarkaPortaliPage() {
  const { darkMode } = useTheme();
  const { hasPermission: yazabilir, loading } = usePermission('Genel', 'Marka Portalı', 'w');
  const [sekme, setSekme] = useState('portal');
  const [onizleme, setOnizleme] = useState(null); // taslak önizlemesi yapılan marka
  const [yenile, setYenile] = useState(0);
  const cerceve = useRef(null);
  const tema = darkMode ? 'dark' : 'light';

  // Fedora teması değişince portala bildir (portal kendi data-theme desteğiyle uygular)
  useEffect(() => {
    const w = cerceve.current?.contentWindow;
    if (w) w.postMessage({ tema }, window.location.origin);
  }, [tema]);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}><Spin size="large" /></div>;
  }

  const iframe = (
    <iframe
      key={`${onizleme || ''}-${yenile}`}
      ref={cerceve}
      title="ATM Grubu Marka Portalı"
      src={portalAdresi({ taslak: Boolean(onizleme), tema, slug: onizleme })}
      style={{ width: '100%', height: yazabilir ? 'calc(100vh - 128px)' : 'calc(100vh - 64px)', border: 0, display: 'block' }}
    />
  );

  if (!yazabilir) return iframe;

  return (
    <div className="nf-module" style={{ padding: '8px 16px 0' }}>
      <Tabs
        activeKey={sekme}
        onChange={setSekme}
        style={{ marginBottom: 0 }}
        items={[
          { key: 'portal', label: onizleme ? `Portal (taslak önizleme: ${onizleme})` : 'Portal', children: iframe },
          {
            key: 'yonetim',
            label: 'Marka Yönetimi',
            children: (
              <MarkaYonetimi
                onOnizle={(slug) => { setOnizleme(slug); setSekme('portal'); }}
                onDegisti={() => setYenile((n) => n + 1)}
              />
            ),
          },
        ]}
        tabBarExtraContent={onizleme ? <a onClick={() => setOnizleme(null)}>Önizlemeden çık</a> : null}
      />
    </div>
  );
}
